export const DOMINICAN_BOUNDS = {
  north: 19.94,
  south: 17.36,
  west: -72.01,
  east: -68.32
};

export const OUT_OF_BOUNDS_MESSAGE =
  "La ubicación está fuera de los límites de República Dominicana.";

export function isWithinDominicanBounds(lat: number, lng: number): boolean {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  return (
    lat <= DOMINICAN_BOUNDS.north &&
    lat >= DOMINICAN_BOUNDS.south &&
    lng >= DOMINICAN_BOUNDS.west &&
    lng <= DOMINICAN_BOUNDS.east
  );
}

// Approximate check to exclude Haiti by testing the point is east of the
// Haiti–DR border line (from Dajabón to Pedernales) while still inside DR bounds.
// Uses a half-plane test with x=lng, y=lat. Cross product sign is negative on DR side.
const BORDER_NORTH = { lng: -71.7, lat: 19.55 }; // near Dajabón
const BORDER_SOUTH = { lng: -71.75, lat: 18.04 }; // near Pedernales

export function isWithinDominicanRepublic(lat: number, lng: number): boolean {
  if (!isWithinDominicanBounds(lat, lng)) return false;
  const x = lng - BORDER_NORTH.lng;
  const y = lat - BORDER_NORTH.lat;
  const dx = BORDER_SOUTH.lng - BORDER_NORTH.lng;
  const dy = BORDER_SOUTH.lat - BORDER_NORTH.lat;
  const cross = x * dy - y * dx;
  // cross <= 0 means east (DR side) relative to the border segment
  return cross <= 0;
}
